module.exports = __webpack_public_path__ + "media/bootstrap-icons/clipboard-32a5ae6c.svg";